import { convertTimeThreshold } from './timeThreshold.js';
import type {
  GapPolicy,
  ThresholdGapPolicy,
} from '../types/timeseries-props.js';

/**
 * Gets the threshold value in milliseconds.
 *
 * If gapPolicy === 'gap' or the threshold is invalid, it fallbacks to 0 (in that way, every gap will remain as gap)
 *
 * @param gapPolicy - given GapPolicy
 * @returns
 */
export function getThresholdValue(gapPolicy: GapPolicy) {
  return isThresholdGapPolicy(gapPolicy)
    ? convertTimeThreshold(gapPolicy.threshold) ?? 0
    : 0;
}

/**
 * Type guard to ensure we are working with the ThresholdGapPolicy.
 *
 * @param gapPolicy - given GapPolicy
 * @returns
 */
function isThresholdGapPolicy(
  gapPolicy: GapPolicy,
): gapPolicy is ThresholdGapPolicy {
  return typeof gapPolicy === 'object' && 'threshold' in gapPolicy;
}
